import {
  pageInfo,
  orderTrajectory,
  detail,
  detailByCustomerOrderNo,
  deleteData,
  initEdit,
  editTransType,
  editReqArriverDate,
  orderUrgent,
  editProject,
  importForEditProject,
  downloadTemplate,
  exportData,
  getOrderTrace,
  downloadFile
} from './../api';
import { Message } from 'element-ui';
import {
  listShipper,
  listProject,
  listShipperProject,
  listOrigin,
  listDest,
  listCompany,
  listShipType
} from '../../../../api'
const orderSearch = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailObj: null,
    orderTrajectoryObj: null,
    companyObj: null,
    shipperObj: null,
    projectObj: null,
    deleteDataObj: null,
    initEditObj: null,
    editTransTypeObj: null,
    editReqArriverDateObj: null,
    orderUrgentObj: null,
    listShipperProjectObj: null,
    editProjectObj: null,
    importForEditProjectObj: null,
    originObj: null,
    destObj: null,
    exportDataObj: null,
    orderTraceObj: null,
    downloadFileObj: null,
    shipTypeObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));

    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    //初始化更新对象事件
    DETAIL(state,data) {
      state.detailObj = data.obj || {};
    },
    DETAIL_BY_CUSTOMERORDERNO(state,data) {
      state.detailObj = data.obj || {};
    },
    ORDER_TRAJECTORY(state,data) {
      state.orderTrajectoryObj = data.obj || {};
    },
    DELETE_DATA(state,data) {
      state.deleteDataObj = data
    },
    INIT_EDIT(state,data) {
      state.initEditObj = data
    },
    EDIT_TRANS_TYPE(state,data) {
      state.editTransTypeObj = data
    },
    EDIT_REQ_ARRIVER_DATE(state,data) {
      state.editReqArriverDateObj = data
    },
    ORDER_URGENT(state,data) {
      state.orderUrgentObj = data;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj || {};
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj || {};
    },
    LIST_PROJECT(state, data) {
      state.projectObj = data.obj || {};
    },
    LIST_SHIPPER_PROJECT(state, data) {
      state.listShipperProjectObj = data.obj;
    },
    EDIT_PROJECT(state,data) {
      state.editProjectObj = data
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_FOR_EDIT_PROJECT(state, data) {
      state.importForEditProjectObj = data;
    },
    LIST_ORIGIN(state, data) {
      state.originObj = data.obj || {};
    },
    LIST_DEST(state, data) {
      state.destObj = data.obj || {};
    },
    GET_ORDER_TRACE(state, data) {
      state.orderTraceObj = data.obj || {};
    },
    DOWNLOAD_FILE(state,data) {
      state.downloadFileObj = data
    },
    LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化更新对象事件
    async detail({commit}, obj){
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    async detailByCustomerOrderNo({commit}, obj){
      let resp = await detailByCustomerOrderNo(obj);
      commit('DETAIL_BY_CUSTOMERORDERNO', resp);
    },
    //初始化更新对象事件
    async orderTrajectory({commit}, obj){
      let resp = await orderTrajectory(obj);
      commit('ORDER_TRAJECTORY', resp);
    },
    //删除订单
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //初始化编辑
    async initEdit({commit}, obj){
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //修改运输方式
    async editTransType({commit}, obj){
      let resp = await editTransType(obj);
      commit('EDIT_TRANS_TYPE', resp);
    },
    //修改要求到达时间
    async editReqArriverDate({commit}, obj){
      let resp = await editReqArriverDate(obj);
      commit('EDIT_REQ_ARRIVER_DATE', resp);
    },
    //加急
    async orderUrgent({commit}, obj){
      let resp = await orderUrgent(obj);
      commit('ORDER_URGENT', resp);
    },
    async listCompany({commit}, obj){
      let resp = await listCompany(obj);
      commit('LIST_COMPANY', resp);
    },
    async listShipper({commit}, obj){
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    async listProject({commit}, obj){
      let resp = await listProject(obj);
      commit('LIST_PROJECT', resp);
    },
    async listShipperProject({commit}, obj){
      let resp = await listShipperProject(obj);
      commit('LIST_SHIPPER_PROJECT', resp);
    },
    //修改项目
    async editProject({commit}, obj){
      let resp = await editProject(obj);
      commit('EDIT_PROJECT', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importForEditProject({ commit }, obj) {
      let resp = await importForEditProject(obj);
      commit('IMPORT_FOR_EDIT_PROJECT', resp);
    },
    //发货方
    async listOrigin({ commit }, obj) {
      let resp = await listOrigin(obj);
      commit('LIST_ORIGIN', resp);
    },
    //收货方
    async listDest({ commit }, obj) {
      let resp = await listDest(obj);
      commit('LIST_DEST', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async getOrderTrace({ commit }, obj) {
      let resp = await getOrderTrace(obj);
      commit('GET_ORDER_TRACE', resp);
    },
    async downloadFile({commit}, obj) {
      let resp = await downloadFile(obj);
      commit('DOWNLOAD_FILE', resp);
    },
    //运输方式
    async listShipType({ commit }, obj) {
      let resp = await listShipType(obj);
      commit('LIST_SHIP_TYPE', resp);
    },
  }
}
export default orderSearch



// WEBPACK FOOTER //
// ./src/page/order/orderSearch/store/orderSearch.store.js